// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../styles/typography.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputGroup-suffix__indicator-separator {
  display: none !important;
}

.inputGroup-suffix__input {
  color: transparent;
}

.inputGroup-suffix__control {
  height: 24px;
  min-height: 24px !important;
  border: none !important;
  background-color: transparent !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.inputGroup-suffix__control--is-focused {
  border: none !important;
  box-shadow: none !important;
  outline: 0 !important;
}

.inputGroup-suffix__dropdown-indicator {
  padding: 0 !important;
}

.inputGroup-suffix__dropdown-indicator svg {
  height: 14px;
}

.inputGroup-suffix__value-container {
  padding: 0 4px !important;
  line-height: 1;
}

.InputGroup--wrapper--y51z5 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.InputGroup--label--ZN_Cx {
}

.InputGroup--inputs--IipzK {
  display: flex;
  align-items: center;
}

.InputGroup--inputs--IipzK > input:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border: 1px solid var(--stat--border);
  border-right: none;
  padding: 0 5px;
  height: 24px;
}

.InputGroup--inputs--IipzK > input:first-child:focus {
  outline: 0;
}

.InputGroup--input-number--zOn79 {
  min-width: 50px;
  -moz-appearance: textfield;
}

.InputGroup--input-number--zOn79::-webkit-outer-spin-button,
.InputGroup--input-number--zOn79::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.InputGroup--suffix--XhEVc {
  min-width: 45px;
  border: 1px solid var(--input--border);
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  height: 24px;
}

.InputGroup--suffixText--vyPiD {
  display: flex;
  align-items: center;
  padding-left: 5px;
  min-width: 40px;
  color: var(--input--disabled);
}
`, "",{"version":3,"sources":["webpack://./src/components/common/controls/InputGroup.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,uBAAuB;EACvB,wCAAwC;EACxC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;AAEA;;AAEA;EACE,aAAa;EACb,mBAAmB;AAErB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,4BAA4B;EAC5B,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EAEE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,6BAA6B;AAC/B","sourcesContent":[":global(.inputGroup-suffix__indicator-separator) {\n  display: none !important;\n}\n\n:global(.inputGroup-suffix__input) {\n  color: transparent;\n}\n\n:global(.inputGroup-suffix__control) {\n  height: 24px;\n  min-height: 24px !important;\n  border: none !important;\n  background-color: transparent !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n}\n\n:global(.inputGroup-suffix__control--is-focused) {\n  border: none !important;\n  box-shadow: none !important;\n  outline: 0 !important;\n}\n\n:global(.inputGroup-suffix__dropdown-indicator) {\n  padding: 0 !important;\n}\n\n:global(.inputGroup-suffix__dropdown-indicator svg) {\n  height: 14px;\n}\n\n:global(.inputGroup-suffix__value-container) {\n  padding: 0 4px !important;\n  line-height: 1;\n}\n\n.wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.label {\n  composes: largeSize from '../../../styles/typography.css';\n}\n\n.inputs {\n  display: flex;\n  align-items: center;\n  composes: smallSize from '../../../styles/typography.css';\n}\n\n.inputs > input:first-child {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  border: 1px solid var(--stat--border);\n  border-right: none;\n  padding: 0 5px;\n  height: 24px;\n}\n\n.inputs > input:first-child:focus {\n  outline: 0;\n}\n\n.input-number {\n  min-width: 50px;\n  -moz-appearance: textfield;\n}\n\n.input-number::-webkit-outer-spin-button,\n.input-number::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.suffix {\n  min-width: 45px;\n  border: 1px solid var(--input--border);\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  height: 24px;\n}\n\n.suffixText {\n  composes: suffix;\n  display: flex;\n  align-items: center;\n  padding-left: 5px;\n  min-width: 40px;\n  color: var(--input--disabled);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `InputGroup--wrapper--y51z5`,
	"label": `InputGroup--label--ZN_Cx ${___CSS_LOADER_ICSS_IMPORT_0___.locals["largeSize"]}`,
	"inputs": `InputGroup--inputs--IipzK ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"input-number": `InputGroup--input-number--zOn79`,
	"suffix": `InputGroup--suffix--XhEVc`,
	"suffixText": `InputGroup--suffixText--vyPiD InputGroup--suffix--XhEVc`
};
export default ___CSS_LOADER_EXPORT___;
